import React, { useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { removeUserData } from '../../../store/slice/userSlice';

const Logout = () => {
  const dispatch = useDispatch();
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    if (isLoggingOut) return;

    setIsLoggingOut(true);
    
    try {
      await axios.post(`${configData.config.UNO_URL}/api/auth/logout`,{},{
        headers: {
          Authorization: `Bearer ${userData?.token}`,
        },
      });
    } catch (error) {
      console.log(error);
    } finally{
      setIsLoggingOut(false);
      localStorage.removeItem("token");
      dispatch(removeUserData());
      window.location.href = "/login"
    }

  };

  return (
    <>
      <span
        className="logout"
        onClick={handleLogout}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '0px',
          pointerEvents: isLoggingOut ? 'none' : 'auto',
          opacity: isLoggingOut ? 0.8 : 1,
        }}
      >
        {isLoggingOut ? (
          <>
            <CircularProgress size={14} color="inherit" />
            Logging out
          </>
        ) : (
          'Logout'
        )}
      </span>
    </>
  );
};

export default Logout;
